module.exports = __webpack_public_path__ + "img/calendario-black.a0c5516a.svg";